import { axiosInstance } from ".";

/**
 * GET /api/admin_portal/v2/activity_logs (PROLINE-3943) — Super Admin only,
 * newest first. Always send `actor_type` (+ `company_id` for a company's log);
 * `page=-1` returns every matching entry (export). Paging meta in headers.
 */
const getActivityLogs = (params = {}) =>
  axiosInstance.get("/activity_logs", { params });

export { getActivityLogs };
